<template>
  <div class="summary">
    <div class="tools no-select">
      <div class="no-select">
        <div class="filters" v-if="metadata.pages">
          <div class="filters-heading">Filters</div>
          <div class="colors">
            <div 
              v-for="(color, i) in hlColors" 
              v-bind:key="i" 
              v-on:click="changeColor(color)" 
              :class="{'color-active': summaryFilters[color.hlClass], 'color': true}"
            >
              <div :class="'circle-base ' + color.baseClass"></div>
            </div>
          </div>
          
          <button type="button" v-if="bookUtils.isMPUB(this.book)" @click="currentHeadingLevel = (currentHeadingLevel === 5) ? 1 : 5; " :class="{'button-active': currentHeadingLevel === 5, 'button': true}">More Headings</button>
          <button type="button" @click="summaryFilters['itsi-annotations'] = !summaryFilters['itsi-annotations'];" :class="{'button-active': summaryFilters['itsi-annotations'], 'button': true}">Annotations</button>
        </div>

        <div class="page-range">
          <div class="page-range-heading">Page Range</div>

          <input v-model="fromPage" @click="$event.target.select()" :class="{'input': true, 'is-danger': !isValidPage(fromPage) }"/>
          to 
          <input v-model="toPage" @click="$event.target.select()" :class="{'input': true, 'is-danger': !isValidPage(toPage) }"/>
        </div>

        <button type="button" class="button is-primary" @click="loadSummary()" :disabled="!isValidPage(fromPage) || !isValidPage(toPage)">Generate</button>
        <div class="right-buttons">
          <div v-on:click.stop="generatePDF()" v-if="!generatingPDF" :class="{'disabled': !isValidPage(fromPage) || !isValidPage(toPage)}" class='icon-button tool' title="Generate PDF Summary">
            <i class="fal fa-file-pdf"></i>
          </div>
          <loading :small="true" v-else/>
        </div>
      </div>
    </div>

    <loading v-if="loading" :text="'Generating summary. Please be patient...'"/>

    <span v-if="error" class="help is-danger">
      {{error}}
    </span>
    <iframe
      v-show="!loading"
      sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
      id="summary-display"
      name="summary-display"
      frameborder="0"
      class="summary-display"
    ></iframe>
    <!-- Hidden container for pdf summary generation -->
    <div ref='viewer' v-show="false"></div>

    <!-- MODALS -->
    <Note
        v-if="noteToView"
        @noteModalClosed="noteToView = undefined; loadSummary()"
        :attachmentId="noteToView"
      />

      <Freehand
        v-if="freehandToView"
        @freehandModalClosed="freehandToView = undefined; loadSummary()"
        :attachmentId="freehandToView"
      />
  </div>
</template>

<script>
  const _ = require('lodash');
  const moment = require('moment');
  const prohibitCopyLength = 300;
  require('moment-timezone');
  moment.tz.setDefault('Africa/Johannesburg');
  
  import Vue from 'vue';
  import utils from '@/utils/utils.js';
  import epubUtils from '@/utils/epubUtils.js';
  import pdfUtils from '@/utils/pdfUtils.js';  
  import bookUtils from '@/utils/bookUtils.js';
  import error from "@/utils/error.js";
  import annotationUtils from '@/utils/annotationUtils.js';
  import storeHelpers from '@/utils/storeHelpers.js';
  import analytics from '@/utils/analytics.js';
  import summaryUtils from '@/utils/summaryUtils.js';  
  import lzjs from 'lzjs';
  import Freehand from "./annotations/Freehand";
  import Note from "./annotations/Note";

  const ITSIBridge = {
    pageLoaded: function() {
      alert("loaded");
      // Interface.pageLoaded();
    },
    parseJSONifString: function(possibleString) {
      return possibleString;
    },
    base64Decode: function(string) {
      return atob(string);
    },
    decompressFromBase64: function(string) {
      return lzjs.decompressFromBase64(string);
    },
    summaryHighlightsAndResourcesSet: function(data) {
    },
    summaryGotoSelector: function(data) {
      var section = data;

      // if(this.bookMetadata && this.bookMetadata.pages) {
      //   const page = bookUtils.getPageFromFile(this.bookMetadata, attachment.section, this.book.format);
      //   return utils.getBookLink(this.book, page);
      // } else {
      //   return utils.getBookLink(this.book, "null") + "?section=" + attachment.section;
      // }
    },
    summaryOpenAttachment: function(attId) {    
      const attachment = storeHelpers.getAttachmentById(handle, attId);
      var optionObj = {
          "from" : 3 // summary
      };

      const resourceObj = storeHelpers.getResourceById(handle, attachment.resource);

      if(resourceObj && resourceObj.category === "note") {
        handle.noteToView = attId;
      } else if(resourceObj && resourceObj.category === "sketch") {
        handle.freehandToView = attId;
      } else {
        utils.openResource(handle, resourceObj, [attId], optionObj);
      }
    },
    summaryDone: function(data) {
    },
    smileyMagic: function(string) {
      return decodeURIComponent(escape(string));
    },
  };

  var pdfInstance, Annotations, pdfHLText, pdfHLTextIndex, summaryData, handle;

  export default {
    name: 'SummaryView',
    components: {
      Note,
      Freehand
    },
    data: function () {
      var t = this;

      return {
        noteToView: undefined,
        freehandToView: undefined,
        bookUtils: bookUtils,
        loading: false,
        error: "",
        book: undefined,
        annotationUtils: annotationUtils,
        fromPage: 1,
        toPage: 1,
        currentHeadingLevel: 5,
        metadata: {},
        summaryFilters: {
          "itsi-annotations": true
        },
        generatingPDF: false
      }
    },
    mounted: async function() {
      handle = this;

      this.hlColors.forEach(color => {
        Vue.set(this.summaryFilters, color.hlClass, true);
      });
      
      this.fromPage = this.$route.params.from;
      this.toPage = this.$route.params.to;

      const bookId = this.$route.params.bookId;
      this.book = storeHelpers.getBookById(this, bookId);

      const url = this.$config.get('ecApi') + "web/books/epub/create/" + this.book._id;
      const response = await axios.get(url);
      this.metadata = response.data;

      if(bookUtils.isValidPageRange(this.book, this.metadata, this.fromPage, this.toPage)) {
        if(bookUtils.isMPUB(this.book)) {
          this.loadSummary()
        } else if(bookUtils.isPDF(this.book)) {
          this.loadPDF();
        } else {
          this.error = "Unknown book type";
        }
      } else {
        this.error = "The page range " + this.fromPage + " to " + this.toPage + " is invalid.";
      }
    },
    computed: {
      summaryFiltersToHide() {
        var toHide = [];
        if(!this.summaryFilters["itsi-annotations"]) {
          toHide.push("itsi-annotations");
        }

        this.hlColors.forEach(color => {
          if(!this.summaryFilters[color.hlClass]) {
            toHide.push(color.hlClass);
          }
        })

        return toHide;
      },
      hlColors() {
        return annotationUtils.getHLPenColors().splice(1);
      }
    },
    methods: {
      loadPDF: async function() {
        var t = this;
        t.loading = true;

        // load the pdf (invisble)
        const {pdfTronInstance, doc, error} = await pdfUtils.loadPDF(t, t.book, t.metadata, t.$refs.viewer); 

        if(error) {
          t.$parent.onBookError(error);
          return;
        }

        pdfInstance = pdfTronInstance;
        Annotations = pdfInstance.Annotations;

        pdfInstance.docViewer.on('documentLoaded', async function() {
          t.loadSummary();
        });

        pdfInstance.docViewer.on('textSelected', function(quads, selectedText, pageIndex) { 
          if(pageIndex + 1 === parseInt(pdfHLText[pdfHLTextIndex].section)) {
            pdfHLText[pdfHLTextIndex].hlText = selectedText;
            pdfHLTextIndex ++;
            t.processPDFHighlight();
          }
        });
      },
      loadSummary: async function() {
        var t = this;

        t.error = "";
        t.loading = true;
        const {bodyHandle} = bookUtils.getSummaryiFrame();

        t.$router.replace({
          params: {
            from: t.fromPage,
            to: t.toPage,
          },
          query: t.$route.query
        });

        // epub
        if(bookUtils.isMPUB(t.book)) {
          summaryData = await summaryUtils.getSummaryData(t, t.book, t.metadata, t.fromPage, t.toPage, t.summaryFiltersToHide, t.currentHeadingLevel);
          
          const summaryUrl = t.$config.get('ecApi') + "web/books/" + t.book._id + "/summary/html";
          axios.post(summaryUrl, summaryData).then(response => {
            bodyHandle.innerHTML = response.data;
            // console.log("response:", response);
            analytics.summary(t);
            t.loading = false;
          }).catch(e => {
            t.error = error.logAndGetError(t, e);
            t.loading = false;
          })
        } 
        // pdf
        else if(bookUtils.isPDF(t.book)) {
          const docViewer = pdfInstance.docViewer;
          const annotManager = docViewer.getAnnotationManager();

          // get all the highlights, resources etc. for the page range
          summaryData = await summaryUtils.getSummaryData(t, t.book, t.metadata, t.fromPage, t.toPage, t.summaryFiltersToHide, t.currentHeadingLevel);

          pdfHLText = [];
          pdfHLTextIndex = 0;

          // console.log("summaryData:", summaryData);

          summaryData.sections.forEach(async function(section) {
            const pageOneBased = parseInt(section);
              // 1. Get all highlights for the page
            const highlightsOnPage = summaryData.highlights[section];

            if(highlightsOnPage) {
              // 2. Filter out incompatible highlights
              var highlightsFiltered = _.filter(highlightsOnPage.content, hlData => hlData.length >= 8);

              // 3. Filter out filtered out highlights
              highlightsFiltered = _.filter(highlightsFiltered, hlData => {
                const hlClass = t.hlColors[hlData[2]-1].hlClass;
                return summaryData.summaryFiltersToHide.indexOf(hlClass) === -1
              });

              // 4. start processing each highlight, waiting for its text to be selected, upon completion will call highlightsProcessed()
              highlightsFiltered.forEach(hlData => {
                pdfHLText.push({section: section, hlData: hlData, hlText: ""});
              });
            }
          });
          t.processPDFHighlight();
        }
      },
      processPDFHighlight() {
        if(pdfHLTextIndex >= pdfHLText.length) {
          this.pdfHighlightsProcessed();
        } else { 
          const pageOneBased = parseInt(pdfHLText[pdfHLTextIndex].section);
          const pageZeroBased = pageOneBased - 1;
          const {x, y , width, height} = pdfUtils.getRectFromHLData(pdfHLText[pdfHLTextIndex].hlData, pdfInstance.docViewer, pageOneBased);
          pdfInstance.docViewer.select({x: x, y: y, pageIndex: pageZeroBased}, {x: x + width, y: y, pageIndex: pageZeroBased});
        }
      },
      pdfHighlightsProcessed: async function() {
        var t = this;

        const path = t.$config.get("localServer") ? "https://app.dev.it.si/reader/" : t.$config.get("basePathFiles");

        const {bodyHandle, documentHandle, windowHandle} = bookUtils.getSummaryiFrame();

        // load summary html template with css
        const summaryUrl = t.$config.get('ecApi') + "web/books/" + t.book._id + "/summary/html";
        const response = await axios.get(path + "static/summary.html");
          
        bodyHandle.innerHTML = response.data;

        windowHandle.ITSIBridge = ITSIBridge;

        epubUtils.injectCSSFile(documentHandle, path + "static/styles/epub-itsi-styles.css");
        epubUtils.injectJSFile(documentHandle, path + "static/scripts/jquery.js");
        t.checkJqueryLoaded(windowHandle, function() {
          epubUtils.injectJSFile(documentHandle, path + "static/scripts/summary.js");
          t.checkSummaryJSLoaded(windowHandle, function() {
            const summaryHTMLCompressed = summaryUtils.getPDFSummaryHTMLCompressed(t, t.metadata, pdfHLText, summaryData);
            windowHandle.renderSummary(t.book.title, t.currentHeadingLevel, JSON.stringify(t.summaryFiltersToHide), false, summaryHTMLCompressed, true, t.book.publisher);
            t.loading = false;
            analytics.summary(t);
          });
        });
      },
      checkJqueryLoaded(windowHandle, callback) {
        var t = this;

        if (windowHandle.$) {
          callback();
        } else {
          setTimeout(function() {
            t.checkJqueryLoaded(windowHandle, callback);
          }, 100);
        }
      },
      checkSummaryJSLoaded(windowHandle, callback) {
        var t = this;

        if (windowHandle.renderSummary) {
          callback();
        } else {
          setTimeout(function() {
            t.checkSummaryJSLoaded(windowHandle, callback);
          }, 100);
        }
      },
      changeColor(color) {
        Vue.set(this.summaryFilters, color.hlClass, !this.summaryFilters[color.hlClass]);
      },
      generatePDF: async function() {
        if(!this.isValidPage(this.fromPage) || !this.isValidPage(this.toPage)) return;

        var t = this;
        t.generatingPDF = true;

        // epub
        if(bookUtils.isMPUB(t.book)) {
          const postData = await summaryUtils.getSummaryData(t, t.book, t.metadata, t.fromPage, t.toPage, t.summaryFiltersToHide, t.currentHeadingLevel);
          const summaryUrl = this.$config.get('ecApi') + "web/books/" + t.book._id + "/summary/pdf";

          axios.post(summaryUrl, postData,
          {
            headers: {
              'Accept': 'application/pdf',
            },
            responseType: 'blob'
          }).then(response => {
            analytics.savePDF(t);
            utils.downloadSummary(response.data, t.book.id + '.pdf', 'application/pdf');
            t.generatingPDF = false;
          }).catch(e => {
              t.generatingPDF = false;
              t.error = error.logAndGetError(t, e);
          });
        }
        // pdf
        else if(bookUtils.isPDF(t.book)) {
          t.generatingPDF = false;
        }
      },
      isValidPage(pageToValidate) {
        var t = this;
        
        if (t.book && bookUtils.isMPUB(t.book)) {
          var isValidPage = t.metadata && t.metadata.pages && t.metadata.pages.find(page => page.page === pageToValidate);
          return isValidPage && bookUtils.isValidPageRange(t.book, t.metadata, t.fromPage, t.toPage);
        } else if (t.book && bookUtils.isPDF(t.book)) {
          var isValidPage = t.metadata && t.metadata.pages && t.metadata.pages.find(page => page.title === pageToValidate);
          return isValidPage && bookUtils.isValidPageRange(t.book, t.metadata, t.fromPage, t.toPage);
        }
      }
    }
  }
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.summary {

  .help.is-danger{
    margin: 20px 0;
    text-align: center;
  }

  .summary-display {
    width: 100%;
    height: calc(100vh - 146px);
  }

  .tools * {
    vertical-align: top;
  }

  .tools {
    width: 100%;
  }

  .colors {
    display: inline-block;
    margin: 0 20px 0 10px;

    .color {
      opacity: 0.3;
    }

    .color-active {
      opacity: 1;
    }
  }

  .filters-heading {
    margin-top: 10px;
    display: inline-block;
  }

  .page-range {
    margin-top: 10px;
    margin-left: 20px;
    display: inline-block;

    input {
      width: 40px;
      text-align: center;
      margin: -5px 10px 0;
      font-size: 12pt;
    }

    .page-range-heading {
      display: inline-block;
    }
  }

  .filters {
    display: inline-block;

    .button {
      text-decoration: line-through;
    }

    .button-active {
      background: green;
      color: white;
      border: 1px solid green;
      text-decoration: none;
    }
  }

  .button {
    margin-top: 7px;
    margin-left: 5px;
    font-size: 10pt;
  }

  .right-buttons {
    float: right;
    margin-top: 8px;
    
    .fal {
      font-size: 20pt;
    }

    .small-loading-container {
      margin-right: -10px;
    }
  }
}
</style>